// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import categoriesListSchema from '@alphaott/common-utils/utils/schemas/categories'

import type { Language } from '@alphaott/api-client/types/languages'

import { FETCH_CHANNEL_LANGUAGES } from '../../actions/channelLanguages'

export type ChannelLanguagesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Language>,
  +result: Array<string>,
  +expires: ?number,
}

const initialState: ChannelLanguagesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  result: [],
  expires: null,
}

const channelLanguages = typeToReducer(
  {
    [FETCH_CHANNEL_LANGUAGES]: {
      LOADING: (state): ChannelLanguagesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): ChannelLanguagesState => {
        const {
          meta: { ttl },
        } = action
        const { result } = normalize(action.payload.data, categoriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          result,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): ChannelLanguagesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { channelLanguages }
